import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { AppService } from '../../app.service';
import { Race } from '../race/race';
import { RaceService } from '../race/race.service';

export type RaceSyncProgressEvent = {
  display: boolean,
  percent: number,
  lastLapTime: moment.Moment,
  lapsCount: number
};

@Component({
  selector: 'mc-race-sync-progress-bar',
  templateUrl: './race-sync-progress-bar.component.html',
  styleUrls: ['./race-sync-progress-bar.component.scss']
})
export class RaceSyncProgressBarComponent implements OnInit {

  @Input() race$: Observable<Race>;

  raceSyncProgress$: Observable<RaceSyncProgressEvent>;

  constructor(
    private readonly appService: AppService,
    private readonly raceService: RaceService
  ) {
  }

  ngOnInit() {
    this.raceSyncProgress$ = this.raceService.createRace$SyncProgress$(this.race$);
  }
}
